<template>
  <v-dialog v-model="showDialog" :persistent="loading" :max-width="900">
    <v-card class="pa-1">
      <modal-bar
        :title="title"
        :loading="loading"
        @onClose="showDialog = false"
      />
      <v-simple-table dense>
        <template #default>
          <thead v-if="!loading">
            <tr class="custom-table-bordered">
              <th
                class="text-center text-body-1 text-dark"
                style="background-color: #fff"
                colspan="7"
              >
                <b>{{ isBilling ? 'Facturación' : 'Pedidos' }} actual</b>
              </th>
            </tr>
            <tr class="custom-table-bordered">
              <td class="text-center table-heading text-body-2">Mes</td>
              <td class="text-center table-heading text-body-2">Facturación</td>
            </tr>
          </thead>
          <tbody v-show="!loading" class="custom-table-bordered">
            <tr
              v-for="(item, index) in getNestedValue(data, currentKeyValue)"
              :key="index"
            >
              <td
                :style="index % 2 == 0 ? 'background-color: #fff;' : ''"
                class="table-heading small text-body-2"
              >
                {{ dateFormat(item[monthKeyValue]) }}
              </td>
              <td
                :style="index % 2 == 0 ? 'background-color: #fff;' : ''"
                class="table-heading text-body-2"
              >
                ${{ number_format(item[amountKeyValue]) }}
              </td>
            </tr>
            <tr style="">
              <td
                colspan="2"
                style=""
                class="table-heading small text-body-2 billing-total"
              >
                <v-row>
                  <v-col cols="6" class="pa-3">
                    <b class="ml-n9">Total =</b>
                  </v-col>
                  <v-col cols="6">
                    <b class="ml-n9"
                      >${{ number_format(data[totalCurrentKeyValue]) }}</b
                    >
                  </v-col>
                </v-row>
              </td>
            </tr>
          </tbody>
          <tbody v-if="loading">
            <tr>
              <td colspan="7">
                <v-progress-linear
                  class="mt-3"
                  indeterminate
                  color="teal"
                ></v-progress-linear>
                <span class="text--disabled"> Cargando información</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-simple-table v-if="!loading" dense>
        <template #default>
          <thead class="">
            <tr class="custom-table-bordered">
              <th class="text-center text-body-1 text-dark" colspan="7">
                <b>{{ isBilling ? 'Facturación' : 'Pedidos' }} Anterior</b>
              </th>
            </tr>
            <tr class="custom-table-bordered">
              <td class="text-center table-heading text-body-2">Mes</td>
              <td class="text-center table-heading text-body-2">Facturación</td>
            </tr>
          </thead>
          <tbody v-if="!loading" class="custom-table-bordered">
            <tr
              v-for="(item, index) in getNestedValue(data, oldKeyValue)"
              :key="index"
            >
              <td
                :style="index % 2 == 0 ? 'background-color: #fff;' : ''"
                class="table-heading small text-body-2"
              >
                {{ dateFormat(item[monthKeyValue]) }}
              </td>
              <td
                :style="index % 2 == 0 ? 'background-color: #fff;' : ''"
                class="table-heading text-body-2"
              >
                ${{ number_format(item[amountKeyValue]) }}
              </td>
            </tr>
            <tr>
              <td
                colspan="2"
                style=""
                class="table-heading small text-body-2 billing-total"
              >
                <v-row>
                  <v-col cols="6" class="pa-3">
                    <b class="ml-n9">Total = </b>
                  </v-col>
                  <v-col cols="6">
                    <b class="ml-n9">
                      ${{ number_format(data[totalOldKeyValue]) }}
                    </b>
                  </v-col>
                </v-row>
              </td>
            </tr>
            <tr class="resume-foot">
              <td colspan="2">
                <div
                  class="d-flex space-around justify-space-around flex-nowrap"
                >
                  <b> Crecimiento = </b>
                  <b>{{ number_format(data[totalPercentKeyValue], false) }}%</b>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-actions>
        <div v-if="!loading" class="mt-3 ml-auto">
          <v-btn dense class="success" @click="showDialog = false">
            Aceptar
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import dates from '@/mixins/dates';
  import MixinHelpers from '@/mixins/helpers';
  import ModalBar from '@/components/modals/ModalBar.vue';

  export default {
    components: {
      ModalBar,
    },
    mixins: [MixinHelpers, dates],
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
      data: {
        default: [],
      },
      title: {
        default: 'Detalle de crecimiento acumulado',
      },
      isBilling: {
        type: Boolean,
        default: true,
      },
      value: {
        type: Boolean,
        default: false,
      },
      currentKeyValue: {
        type: String,
        default: 'FACACT.FACACT',
      },
      oldKeyValue: {
        type: String,
        default: 'FACANT.FACANT',
      },
      monthKeyValue: {
        type: String,
        default: 'MESFAC',
      },
      amountKeyValue: {
        type: String,
        default: 'MONFAC',
      },
      totalCurrentKeyValue: {
        type: String,
        default: 'TOTALFACACT',
      },
      totalOldKeyValue: {
        type: String,
        default: 'TOTALFACANT',
      },
      totalPercentKeyValue: {
        type: String,
        default: 'PORCREC',
      },
      inputDateFormat: {
        type: String,
        default: 'YYYYMM',
      },
      outputDateFormat: {
        type: String,
        default: 'MM/YYYY',
      },
    },
    computed: {
      showDialog: {
        set(value) {
          this.$emit('input', value);
        },
        get() {
          return this.value;
        },
      },
    },

    methods: {
      dateFormat(date) {
        return this.removeTimeFromDate(
          date,
          this.inputDateFormat,
          this.outputDateFormat
        );
      },
      getNestedValue(obj, path) {
        if (!obj || typeof path !== 'string') return '';
        try {
          const result = path
            .split('.')
            .reduce(
              (acc, key) =>
                acc && acc[key] !== undefined ? acc[key] : undefined,
              obj
            );
          return result !== undefined ? result : [];
        } catch (e) {
          return e;
        }
      },
    },
  };
</script>

<style scoped>
  .resume-foot {
    background: #ffd75e 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
    border: 1px solid #dde1e6;
  }
  .billing-total {
    background-color: #fff;
    -webkit-box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
    box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  }
</style>
